import { useMemo } from "react";

let counter = 0;

/**
 * Provide a random value that can be used e.g. as id to form fields.
 */
export function useRandomId(): string {
  return useMemo(() => `$generated-${++counter}`, []);
}
